
<div class="container-fluid webView" id="profitloss">
    <!-- Header -->
    <div class="row"> 
        <div class="col-md-12" style="text-align: center;margin-top: 20px;">
            <span style="font-size: 20px">{{AgencyName}}</span><br>
            <span style="font-size: 18px; font-weight: bold;">Profit & Loss</span><br>
            <label style="font-weight: normal;">{{fromDate | date :'dd-MMM-yy'}} to {{toDate | date:'dd-MMM-yy'}}</label>
        </div>
    </div>

    <!-- Body -->
    <div class="row marginZero">
        <div class="col-md-12 mainCard table-bordered" style="padding: 0px !important;">
            <!-- Left -->  
            <div class="col-md-6 mainCardHeader" style="display: inline-block; border-right: 1px solid #ddd; padding: 0px; vertical-align: top;">
                <div class="col-md-12" style="text-align: center; border-bottom: 1px solid #ddd; background-color: #f5f5f5; border-top-left-radius: 25px; padding: 10px;">
                    Expense
                </div>
                <div class="col-md-12" *ngFor="let Stock of AccurateProfitOrLoss" style="padding-top: 10px; font-size: 13px;">
                    <div style="margin-bottom: 10px;">
                        <span style="font-weight: bold;">Opening Stock</span> &nbsp;
                        <span class="pull-right"><span style="font-family: Arial;">₹</span>{{Stock.OpeningStock | cRDB}}</span>
                    </div>
                </div>
                <div class="col-md-12" *ngFor="let Heads of BindRecordLeft" style="font-size: 13px;">
                    <div style="margin-bottom: 10px;" *ngIf="(Heads.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                        <span style="font-weight: bold; cursor: pointer;" [routerLink]="['/accounts', {id: Heads.HeadID, h:1}]">{{Heads.HeadName}}</span>&nbsp;
                        <span class="pull-right"><span style="font-family: Arial;">₹</span>{{Heads.CloBal | cRDB}}</span>
                        <div class="col-md-12" style="padding-right: 0px; margin-bottom: 10px;">
                            <div class="col-md-12" style="padding-left: 20px; padding-right: 40px;" *ngFor="let SubHead of Heads.SubHead">
                                <div *ngIf="(SubHead.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                                    <span style="cursor: pointer;">{{SubHead.HeadName}}</span>
                                    <span class="pull-right"><span style="font-family: Arial; font-weight: normal;">₹</span>{{SubHead.CloBal | cRDB}}</span>
                                </div>
                            </div>
                            <div class="col-md-12" style="padding-left: 20px; padding-right: 40px;" *ngFor="let SubLedger of Heads.Ledger">
                                <div *ngIf="(SubLedger.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                                    <span style="cursor: pointer; font-style: italic;" [routerLink]="['/accounts', {id: SubLedger.LedgerID, h:0}]">{{SubLedger.LedgerName}}</span>
                                    <span class="pull-right"><span style="font-family: Arial; font-weight: normal;">₹</span>{{SubLedger.CloBal | cRDB}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>   
                
                <div class="col-md-12">
                    <div style="margin-bottom: 10px;" *ngIf="ProfitOrLoss > 0">
                        <span style="font-weight: bold;">Current Profit</span> &nbsp;
                        <span class="pull-right"><span style="font-family: Arial;">₹</span>{{ProfitOrLoss | cRDB}}</span>
                    </div>
                </div>
            </div>  
            <!-- Right -->
            <div class="col-md-6 mainCardHeader" style="display: inline-block;border-left: 1px solid #ddd; padding: 0px; vertical-align: top;">
                <div class="col-md-12" style="text-align: center; border-bottom: 1px solid #ddd; background-color: #f5f5f5; border-top-right-radius: 25px; padding: 10px;">
                    Income
                </div>
                <div class="col-md-12" *ngFor="let Stock of AccurateProfitOrLoss" style="padding-top: 10px; font-size: 13px;">
                    <div style="margin-bottom: 10px;">
                        <span style="font-weight: bold;">Closing Stock</span> &nbsp;
                        <span class="pull-right"><span style="font-family: Arial;">₹</span>{{Stock.ClosingStock | cRDB}}</span>
                    </div>
                </div>
                <div class="col-md-12" *ngFor="let Heads of BindRecordRight" style="font-size: 13px;">
                    <div style="margin-bottom: 10px;" *ngIf="(Heads.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                        <span style="font-weight: bold; cursor: pointer;" [routerLink]="['/accounts', {id: Heads.HeadID, h:1}]">{{Heads.HeadName}}</span>&nbsp;
                        <span class="pull-right"><span style="font-family: Arial;">₹</span>{{Heads.CloBal | cRDB}}</span>
                        <div class="col-md-12" style="padding-right: 0px; margin-bottom: 10px;">
                            <div class="col-md-12" style="padding-left: 20px; padding-right: 40px;" *ngFor="let SubHead of Heads.SubHead">
                                <div *ngIf="(SubHead.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                                    <span style="cursor: pointer;" [routerLink]="['/accounts', {id: SubHead.HeadID, h:1}]">{{SubHead.HeadName}}</span>
                                    <span class="pull-right"><span style="font-family: Arial;">₹</span>{{SubHead.CloBal | cRDB}}</span>
                                </div>
                            </div>
                            <div class="col-md-12" style="padding-left: 20px; padding-right: 40px;" *ngFor="let SubLedger of Heads.Ledger">
                                <div *ngIf="(SubLedger.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                                    <span style="cursor: pointer; font-style: italic;" [routerLink]="['/accounts', {id: SubLedger.LedgerID, h:0}]">{{SubLedger.LedgerName}}</span>
                                    <span class="pull-right"><span style="font-family: Arial;">₹</span>{{SubLedger.CloBal | cRDB}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12" style="font-size: 13px;">
                    <div style="margin-bottom: 10px;" *ngIf="ProfitOrLoss < 0">
                        <span style="font-weight: bold;">Current Loss</span> &nbsp;
                        <span class="pull-right" style="font-weight: bold;"><span style="font-family: Arial;">₹</span>{{ProfitOrLoss | cRDB }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12 table-bordered" style="padding-left: 0px; padding-right: 0px; border-top: none; margin-bottom: 30px; border-bottom-left-radius: 25px; border-bottom-right-radius: 25px; font-size: 13px;" id="MainDiv1">
            <div class="col-md-6" style="border-right: 1px solid #ddd; padding-left: 0px; padding-right: 0px; display: inline-block;">
                <div class="col-md-12" style="padding-right: 15px; padding-top: 3px; padding-bottom: 3px;">
                    <div style="margin-bottom: 10px;">
                        <span style="font-weight: bold;">Total</span>
                        <span class="pull-right" style="font-weight: bold;"><span style="font-family: Arial;">₹</span>{{GrandExpense | cRDB}}</span>
                    </div>
                </div>
            </div>

            <div class="col-md-6" style="padding-left: 0px; padding-right: 0px; display: inline-block;">
                <div class="col-md-12" style="padding-right: 15px; padding-top: 3px;">
                    <div style="margin-bottom: 10px;">
                        <span style="font-weight: bold;">Total</span>
                        <span class="pull-right" style="font-weight: bold;"><span style="font-family: Arial;">₹</span>{{GrandIncome | cRDB}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
